export function normalizeValue<T extends string>(value: T | undefined | null): T | undefined {
	// Assume we have a string if the trim function exists
	if (typeof value?.trim !== 'function') {
		return undefined;
	}

	const trimmed = value.trim();
	if (!trimmed.length) {
		return undefined;
	}

	return trimmed as T;
}
